module.exports = __webpack_public_path__ + "img/60m8.d0fd0240.jpg";